/* eslint-disable */

// global.jQuery = require('jquery');
// var $ = global.jQuery;
// window.$ = $;
import jQuery from 'jquery'
window.jQuery = jQuery

import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

//Vue Resource
import VueResource from "vue-resource"
//Sweet Alert
import VueSweetAlert from 'vue-sweetalert'
//Vee Validate
import VeeValidate from 'vee-validate'
//Vue Moment 
import VueMoment from 'vue-moment'
//Toggle Button
import ToggleButton from 'vue-js-toggle-button' 
// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'
//Vue Mask
import VueTheMask from 'vue-the-mask'
// Bootstrap Vue
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
// Bootstrap CSS and VUE CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Signature Pad
import VueSignaturePad from 'vue-signature-pad'
// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// Vue Full-Calendar
import FullCalendar from "vue-full-calendar"; 
// CSS Full-Calendar
import "fullcalendar/dist/fullcalendar.min.css"; 
// Router setup
import routes from './routes/routes'
// Light box
import Lightbox from 'vue-easy-lightbox'
// VUEX STORE 
import store from './store'

/*
|----------------------------------------------------------------------
|  INITIALIZE PLUGINS 
|----------------------------------------------------------------------
*/ 

// Light box
Vue.use(Lightbox);
// Vuex
Vue.use(store)
// full calendar
Vue.use(FullCalendar); 
// Element UI
Vue.use(ElementUI);
// Signature pad
Vue.use(VueSignaturePad);
// Input Mask
Vue.use(VueTheMask)
// Plugin setup
Vue.use(VueSweetAlert)
// Use in http.post
Vue.use(VueResource)
// Use in routing
Vue.use(VueRouter)
//Light Bootstrap
Vue.use(LightBootstrap)
// Bootstrap vue 
Vue.use(BootstrapVue)
// Form Validation
Vue.use(VeeValidate);
// Vue Moment
Vue.use(VueMoment);
//toggle switch
Vue.use(ToggleButton)

/*
|----------------------------------------------------------------------
|  CONFIGURE ROUTER
|----------------------------------------------------------------------
*/ 
const router = new VueRouter({
  routes,
  linkActiveClass: 'nav-item active',
  mode:'history'
})

/*
|----------------------------------------------------------------------
|  INITIALIZE GLOBAL
|----------------------------------------------------------------------
*/ 
window.axios = require('axios');
window.moment = require('moment-business-days');
//window.axios.defaults.baseURL = "http://localhost:9090";
window.axios.defaults.baseURL = "https://endpoint.blueprintbusinesssolutionscorp.com";

/*
|----------------------------------------------------------------------
|  GLOBAL TEXT FORMATING
|----------------------------------------------------------------------
*/  

moment.updateLocale('us', {
  workingWeekdays: [1, 2, 3, 4, 5]
})

Vue.filter('uppercase', function (value) {
  if (!value) return '';
	return value.toUpperCase()
})

Vue.filter('capitalize',function (value){
    if (!value) return '';
    value = value.toString();
    return value.replace(/\w\S*/g, function (txt) {
       return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
})

Vue.prototype.getBirth = function(date){
  return moment(date).format('MMM DD');
}

Vue.prototype.getDate = function(date){
  return moment(date).format('MMM DD YYYY');
}
Vue.prototype.years = function(value){
    const currentYear = new Date().getFullYear();
    let years = []
    for (let year =value; year <= currentYear; year++) {
       years.push(year);
    }
    return years
}

Date.prototype.addHours = function(h) {
  this.setTime(this.getTime() + (h*60*60*1000));
  return this;
}

Vue.prototype.yearCount = function(date){
  return  moment().diff(moment(date), "years",false)
}

Vue.prototype.formatMoney = function(value){
  let val = (value/1).toFixed(2).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}
/*
|----------------------------------------------------------------------
| GLOBAL HEADER INTERCEPTORS FOR TOKEN & CORS
|----------------------------------------------------------------------
*/ 

axios.interceptors.request.use(config => {
  config.headers.common['Authorization'] = "Bearer " + localStorage.getItem("token");
  config.headers.get['Accepts'] = 'application/json';
  config.headers.get['Access-Control-Allow-Origin'] = '*';
  config.headers.get['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
 return config;
});

/*
|----------------------------------------------------------------------
|   ROUTE GUARD
|----------------------------------------------------------------------
*/ 

router.beforeEach((to, from, next) => {
    
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
       next({ name: 'Login-Layout' })
     return
  }

  if(to.path === '/login' && store.state.isLoggedIn) {
      next({ name: 'Dashboard' })  
  }  

   document.title = `HRIS - ${to.name}`
    next()
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router
})




// WEBPACK FOOTER //
// ./src/main.js